module.exports = __webpack_public_path__ + "img/medical-partnership.58a7d514.jpg";